import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ColDef, ExcelExportParams,GridReadyEvent, ISetFilterParams, themeQuartz, ValueFormatterParams } from 'ag-grid-community';
import { CommentDialogComponent } from 'src/app/shared/comment-dialog/comment-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Config } from 'src/app/app-constant';



@Component({
  selector: 'app-employee-tooltip-dialog',
  templateUrl: './employee-tooltip-dialog.component.html',
  styleUrls: ['./employee-tooltip-dialog.component.scss'],
})
export class EmployeeTooltipDialogComponent implements OnInit {
  employeesWithColor: any[] = [];
  columnDefs: any[] = [];
  rowData: any[] = [];


  constructor(
    public dialogRef: MatDialogRef<EmployeeTooltipDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog, private config: Config
  ) { }





  ngOnInit() {
    if (!Array.isArray(this.data.employees)) {


      this.data.employees = [];
    }
    if (!Array.isArray(this.data.departmentsColor)) {
      console.error('Error: departmentsColor is not an array', this.data);
      this.data.departmentsColor = [];
    }


    this.data.employees = this.data.employees.map((emp: any) => {
      const department = this.data.departmentsColor.find(
        (dept: any) => dept.departmentName === emp.department
      );
      return {
        ...emp,
        departmentColor: department ? department.departmentColor : '#000000'
      };
    });
    this.rowData = this.data.employees;

    this.columnDefs = [
      { headerName: "Employee Name", field: "employeeName" },
      { headerName: "Department", field: "department"}
    ];
   
    console.log("Row data:", this.rowData);
  console.log("Column defs:", this.columnDefs);
  console.log("Employees in dialog:", this.data.employees);
  }



  downloadTrendReport(employees: any[]) {
    const header = ["Employee Name", "Department"];
    const csvRows = [header];

    employees.forEach((emp: any) => {
      csvRows.push([
        emp.employeeName,
        emp.department
      ]);
    });

    let csvContent = "data:text/csv;charset=utf-8," + csvRows.map(row => row.join(",")).join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "employeesData.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }


  
  // --------------------------------AG GRID CODE---------------------------------------------------------
  gridApi: any;
  paginationPageSizeSelector = [5, 10, 20,50,100,200,500,1000];
  pagination = true;
  paginationPageSize = 10;
  detailRowAutoHeight = true;

  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 100,
    filter: true,
    resizable: true,
    sortable: true,
    floatingFilter: false,  // ✅ small filter box under header
  };
  
  gridOptions: any = {
    defaultColDef: {
      resizable: true,
      sortable: true,
      filter: true,
      floatingFilter: true,
      minWidth: 80,
  
      // ✅ add this
      cellClass: (p: any) => (p.node.rowIndex % 2 === 0 ? 'cell-even' : 'cell-odd')
    },
    context: { componentParent: this },
    rowSelection: 'single',
    localeText: {
      noRowsToShow: 'No Data Found'  // default text ko replace karna hai 'No Rows To Show' to 'No Data Found'
    }
  };

  openCommentModal(text: string,commentType:any) {
    this.dialog.open(CommentDialogComponent, {
      width: '600px',
      data: { 
        text: text,
        commentType: commentType
      }
    });
  
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
  
    setTimeout(() => {
      params.api.sizeColumnsToFit();
      params.api.refreshCells();
    }, 50);
  }
  
  formatStatus(value: any): string {
    if (!value || typeof value !== 'string') {
      return 'N/A'; // fallback agar value string na ho
    }

    // Camel Case → Title Case
    return value
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  formatDate(value: any): string {
    if (!value) return 'N/A';
  
    const date = new Date(value);
    if (isNaN(date.getTime())) return 'Invalid Date';
  
    // dd-MM-yyyy format
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
  
    return `${day}-${month}-${year}`;
  }

  
  // Helper function to convert any date string into dd-MM-yyyy
  formatDateOnly(dateStr: string | null): string | null {
    if (!dateStr) return null;
  
    let datePart = dateStr;
    if (dateStr.includes('T')) {
      datePart = dateStr.split('T')[0];  
    }
  
    const [y, m, d] = datePart.split('-').map(Number);
    if (!y || !m || !d) return null;
  
    // Date object 
    const date = new Date(y, m - 1, d);
  
    // Format dd-MM-yyyy
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }
  
  // ✅ Global search function
  onFilterTextBoxChanged(value: string = '') {
    if (!this.gridApi) return;
  
    // v31+ way:
    this.gridApi.setGridOption('quickFilterText', value ?? '');
   
  }

  onBtExport() {
    const params: ExcelExportParams = {
      fileName: 'Report' + new Date().toISOString().slice(0, 10) + '.xlsx',
      sheetName: 'Report',
      exportAsExcelTable: {
        showRowStripes: true,
        name: 'ReportTable'
      },
      processCellCallback: (cell) => {
        const header = cell.column.getColDef().headerName;
        const value = cell.value;

        // 1. Date Formatting (for specific headers)
        const dateColumns = ['date', 'dateOfExpense']; // <- field names ya headerName use karo

        if (dateColumns.includes(cell.column.getColId()) && cell.value) {
          const date = new Date(cell.value);
          if (!isNaN(date.getTime())) {
            return (
              ('0' + date.getDate()).slice(-2) +
              '-' +
              ('0' + (date.getMonth() + 1)).slice(-2) +
              '-' +
              date.getFullYear()
            );
          }
        }

        // 2. Status Formatting (make it human readable)
        if (header === 'Status' && value) {
          return value
            .toString()
            .toLowerCase()
            .replace(/_/g, ' ') // replace underscores with space
            .replace(/\b\w/g, (char: any) => char.toUpperCase()); // capitalize each word
        }

        return value;
      }
    };

    this.gridApi.exportDataAsExcel(params);
  }
  
  approvalRenderer(params: any) {
    if (!params.value) return '';
        const status = params.value.toUpperCase();
      
        let color = '';
        if (status === 'APPROVED') {
          color = '#4caf50'; // green
        } else if (status === 'REJECTED') {
          color = '#f44336'; // red
        } else if (status === 'PENDING') {
          color = '#ff9800'; // orange
        }
      
        return `
          <span style="
            border: 1px solid ${color};
            color: ${color};
            padding: 4px 10px;
            border-radius: 12px;
            font-size: 12px;
            font-weight: 500;
            display: inline-block;
            line-height: 20px;
            white-space: nowrap;
          ">
        ${status.charAt(0) + status.slice(1).toLowerCase()}
      </span>
    `;
  }

  statusFormatter(params: any): string {
    if (!params.value) return '';
  
    const valueUpper = params.value.toUpperCase();
  
    // 🔹 Status → Color map
    const statusColors: Record<string, string> = {
      'APPROVED_BY_FINANCE_BUT_NOT_PAID': '#4caf50', // green
      'APPROVED_BY_MANAGER_SENT_TO_FINANCE': '#4caf50',
      'APPROVED_BY_MANAGER_REJECTED_BY_FINANCE': '#f44336', // red
      'REJECTED_BY_MANAGER': '#f44336',
      'PENDING_WITH_MANAGER': '#ff9800' // orange
    };
  
    // 🔹 Default color = grey
    const color =
      Object.keys(statusColors).find(key => valueUpper.includes(key))
        ? statusColors[
            Object.keys(statusColors).find(key => valueUpper.includes(key))!
          ]
        : '#999';
  
    // 🔹 Convert to Title Case
    const formattedText = params.value
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  
    return `
      <span style="
        border: 1px solid ${color};
        color: ${color};
        padding: 4px 10px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 500;
        display: inline-block;
        white-space: normal;
        word-wrap: break-word;
        line-height: 1.4em;
        animation: fadeInScale 0.3s ease-in-out;
        max-width: 100%;
      ">
        ${formattedText}
      </span>
    `;
  }
  
  dateRenderer(params: any) {
    if (!params.value) return '';
    const date = new Date(params.value);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  dateComparator(valueA: string, valueB: string) {
    const parseDate = (value: string) => {
      if (!value) return null;
      // Agar backend se yyyy-mm-dd aa raha hai:
      if (value.includes('-') && value.indexOf('-') === 4) {
        return new Date(value).getTime();
      }
      // Agar already dd-mm-yyyy format hai:
      const [day, month, year] = value.split('-').map(Number);
      return new Date(year, month - 1, day).getTime();
    };

    const dateA = parseDate(valueA);
    const dateB = parseDate(valueB);

    if (dateA === dateB) return 0;
    if (dateA == null) return -1;
    if (dateB == null) return 1;
    return dateA - dateB;
  }

  openFile(fileUrl: string) {
    window.open(fileUrl, '_blank');
  }
  downloadRenderer = (params: any) => {
    
    const fileUrl = `${this.config.downloadFile}${params.value}`;
    if (!params.value) return '';
    const img = document.createElement('img');
    img.src = 'assets/icon/yellowdownload.png'; // replace with your icon path
    img.alt = 'download';
    img.style.width = '18px';
    img.style.height = '18px';
    img.style.cursor = 'pointer';
    img.title = params.value;
    img.addEventListener('click', (e) => {
      e.stopPropagation();
      // open file in new tab
      window.open(fileUrl, '_blank');
    });
    return img;
  }

  downloadDialogRenderer(fileName: string): string {
    if (!fileName) return '';
    return `${this.config.downloadFile}${fileName}`;
  }
  selectedRow: any;
  isDetailsOpen = false;
  onRowClicked(event: any) {
    this.selectedRow = event.data;
    this.isDetailsOpen = true;
  }
  closeDetails() {
    this.isDetailsOpen = false;
  }

 isClicked = false;
 searchTaskString: string = '';

 

  resetGrid() {
    this.isClicked = false; // Trigger animation
  
    if (this.gridApi) {
      // ✅ Reset filters & sorting
      this.gridApi.setFilterModel(null);
      // this.gridApi.setSortModel(null);
      this.gridApi.deselectAll();
  
      // ✅ Reset quick filter (search box)
      this.searchTaskString = '';
      this.gridApi.setGridOption('quickFilterText', ''); // Clears quick filter text
  
      // ✅ Reset pagination
      this.paginationPageSize = 10;
      this.gridApi.setGridOption('paginationPageSize', this.paginationPageSize);
      this.gridApi.paginationGoToFirstPage();
  
      // ✅ Force refresh so UI input also clears
      this.gridApi.refreshCells();
      this.gridApi.resetColumnState();         // ✅ Reset columns
    }
  }

  

}
